import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/services/utils.service';
import { SharedService } from 'src/app/services/shared.service';
import { SesionService } from 'src/app/services/sesion.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {
  nombreSistema: String = environment.ENVIRONMENT.NOMBRE_SISTEMA;
  usuario: any = {};
  subscription: any;

  constructor(private router: Router, public sesionService: SesionService, private utilsService: UtilsService, private sharedService: SharedService) {
    this.subscription = this.sharedService.getUserData().subscribe(data => {
      this.usuario = data;
      //console.log('this.usuario', this.usuario);
    });
  }

  ngOnInit(): void {
    this.checkRoute(this.router.url);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkRoute(url) {
    this.sesionService.menus.map((menu) => {
      menu.subitems.map((submenu) => {
        if (submenu.path === url) {
          this.sesionService.keySelected = menu.key;
          return;
        }
      });
    });
  }

}
